import { ConfigModel } from '@ibe/services';

import useAppService from './useAppService';

function useConfig(): ConfigModel {
  const appService = useAppService();
  return appService.config; // it's a mobx-observable now, but pls don't abuse
}

export default useConfig;
